import { render, staticRenderFns } from "./VmToggle.vue?vue&type=template&id=af801dee&scoped=true&"
import script from "./VmToggle.vue?vue&type=script&lang=js&"
export * from "./VmToggle.vue?vue&type=script&lang=js&"
import style0 from "./VmToggle.vue?vue&type=style&index=0&id=af801dee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af801dee",
  null
  
)

export default component.exports